export default {
    dev: 'http://39.105.131.120:8000/',
    pro: 'http://localhost:3000' 
}